export default (theme: any) => ({
    root: {
        flexGrow: 1,
    },

    button: {
        marginLeft: '25%',
        color: theme.palette.primary.main,
    },

    datatableCardContent: {},

    cardHeaderTitle: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '50px',
        },
    },

    cardHeaderIcon: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '50px',
        },
    },

    cardHeaderIconStyle: {
        backgroundColor: '#D5E0F6',
        color: 'white',
        borderRadius: '4px',
        padding: '3px',
    },

    actionButton: {
        minWidth: '100%',
        borderRadius: '2px',
    },

    pagination: {
        paddingBottom: '10px',
    },

    paginationUl: {
        flexWrap: 'nowrap',
    },

    firstRow: {
        paddingBottom: '25px',
    },

    searchField: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '20px',
            width: '80%',
        },
    },

    searchIcon: {
        maxWidth: '28px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '10px',
        },
    },

    gridItemContent: {
        marginTop: '5px',
        marginBottom: '10px',
        marginLeft: '5px',
        marginRight: '5px',
        width: '100%',
    },

    menuButton: {
        padding: '15px 20px',
        borderBottom: 'solid 2px',
        borderBottomColor: theme.palette.lightGrey.main,
        margin: '0px 30px',
    },

    menu: {
        padding: '20px',
    },

    textfieldWithTooltip: {
        display: 'flex',
        justifyContent: 'flext-start',
        alignItems: 'center',
        gap: '1rem',
    },
})
